import { ErrorResponse } from "../../../domain/error.interface";

/**
 * SIMS-7604 — Members-flow budget-gate messaging, matching the EnrollParticipant
 * wording. The legacy v1 backend returns HTTP 422 for a BLOCK-mode over-threshold
 * program (its error envelope carries no error code, only statusCode + message),
 * and `budgetWarning: true` in the success body for WARN mode.
 */

export const BUDGET_BLOCK_MESSAGE =
	"This program has reached its budget limit, so new enrollments are blocked. Please contact your account administrator.";

export const BUDGET_WARNING_MESSAGE =
	"This program has reached its budget threshold. The enrollment was created; please review the program budget.";

/**
 * True when a caught error is the v1 budget BLOCK gate (HTTP 422 whose message
 * references the budget threshold). Used to show BUDGET_BLOCK_MESSAGE instead of
 * the raw backend text.
 */
export const isBudgetBlockError = (error: unknown): boolean => {
	const e = error as ErrorResponse | undefined;
	const text = Array.isArray(e?.message) ? (e?.message?.join(" ") ?? "") : "";
	return e?.statusCode === 422 && /budget/i.test(text);
};
